import { FC } from "react";
import { useTranslation } from "../../../contexts/useTranslation";

const SwitchingToVoiceModeMessage: FC = () => {
  const { translate } = useTranslation();

  return (
    <div className="flex items-center justify-center text-lastbot-icon-muted h-[56px]">
      {translate("switching_to_voice_mode")}
    </div>
  );
};

export default SwitchingToVoiceModeMessage;
